import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Flex,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  useToast,
  Heading,
  FormControl,
  FormLabel,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Select,
  Stack,
  Switch,
} from "@chakra-ui/react";
import { useMsal } from "@azure/msal-react";
import { useAppContext } from "../../../context/AppContext";
import {
  fetchQuickLinks,
  addQuickLink,
  updateQuickLink,
  deleteQuickLink,
} from "../../../services/AdminServices/QuickLinks";
import { Quicklink } from "../../../models/quicklink";
import { quickLinkEnumId } from "./quickLinkRoleEnum";
import { ProjectLinks } from "../../../models/ProjectLinks";

const QuickLinks: React.FC = () => {
  const [name, setName] = useState(""); // get form database
  const [description, setDescription] = useState(""); // get form database
  const [URL, setURL] = useState(""); // get from database
  const [isActive, setIsActive] = useState(true); // get form database

  const [sites, setSites] = useState<ProjectLinks[]>([]); // Array to store sites

  const [editingId, setEditingId] = useState<number | null>(null); // for edit mode
  const [quickLinkId, setquickLinkId] = useState<number | null>(null);

  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [itemsPerPage, setItemsPerPage] = useState(10); // Items per page

  // api integration
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const toast = useToast();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
  const [deleteSiteName, setDeleteSiteName] = useState<string | null>(null);
  // tenant id
  const { accessToken, userData } = useAppContext();
  const tenantID = userData?.tenantID || 0;

  const [selectedQuickLinkRole, setSelectedQuickLinkRole] =
    useState<string>("");

  const [selectedType, setSelectedType] = useState<string>("");

  const handlePlatformChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedQuickLinkRole(e.target.value);
    setSelectedType("");
  };
  const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedType(e.target.value);
  };

  const isValidUrl = /^https?:\/\//i.test(URL);

  const getTypeOptions = () => {
    if (selectedQuickLinkRole === "SharePoint") {
      return [
        { value: "Site", label: "Site" },
        { value: "Library", label: "Library" },
        { value: "Folder", label: "Folder" },
      ];
    } else {
      return [{ value: "Folder", label: "Folder" }];
    }
  };

  const handleSave = async () => {
    // Validate all required fields except descipation
    if (!name || !URL || !selectedQuickLinkRole || !selectedType) {
      toast({
        position: "top",
        title: "Missing fields",
        description: "All fields are required. Please fill in all the details.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (!name || !URL || !isValidUrl) {
      toast({
        position: "top",
        title: "Invalid Url",
        description: "Name and URL with http:// or https:// are required.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (!accessToken) {
      toast({
        position: "top",
        title: "Authentication Error",
        description: "Access token is missing. Please log in again.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    setError(null);

    const quickLinkPayload = {
      name,
      description,
      URL,
      source: selectedQuickLinkRole,
      isActive,
      createdBy: userData?.userID,
      type: selectedType, // Add type to payload
    };

    try {
      if (editingId !== null) {
        // Update Quick Link Logic
        // const QuickLinkID = sites[editingId].quickLinkID;

        const siteUpdatedData = {
          ...quickLinkPayload,
          ProjectLinkID: quickLinkId,
          updatedBy: userData?.userID,
        };
        await updateQuickLink(siteUpdatedData, accessToken, tenantID);
        // const response = await updateQuickLink(siteUpdatedData, accessToken);

        // if (typeof response === "object") {
        //   setSites((prev) =>
        //     prev.map((site, index) =>
        //       index === editingId ? { ...site, ...response } : site
        //     )
        //   );
        // } else {
        //   console.warn("Server response is not valid JSON:", response);
        //   setSites((prev) =>
        //     prev.map((site, index) =>
        //       index === editingId ? { ...site, ...siteUpdatedData } : site
        //     )
        //   );
        // }

        // getQuickLinks();

        toast({
          position: "top",
          title: "Project Link",
          description: "The links details have been updated successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        // Add New Quick Link Logic
        // const newSite = { tenantID, name, description, URL, isActive };
        await addQuickLink(quickLinkPayload, accessToken, tenantID);
        // const response = await addQuickLink(quickLinkPayload, accessToken);

        // if (typeof response === "object") {
        //   setSites((prev) => [...prev, response]);
        // } else {
        //   console.warn("Server response is not valid JSON:", response);
        //   setSites((prev) => [...prev, newSite]);
        // }

        // getQuickLinks();

        toast({
          position: "top",
          title: "Poject Saved",
          description: "New link has been saved successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
      getQuickLinks();
    } catch (error: any) {
      console.error("Save Error:", error);
      toast({
        position: "top",
        title: editingId !== null ? "Update Failed" : "Add Failed",
        description: "An unexpected error occurred.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });

      setError(
        editingId !== null ? "Failed to update site." : "Failed to save site."
      );
    } finally {
      setLoading(false);
      handleCloseModal(); // Ensure this closes the modal if it's being used
    }
  };

  const handleEdit = (siteData: ProjectLinks) => {


    // Get the global index of the user in the full list
    // const globalIndex = index + (currentPage - 1) * itemsPerPage;
    // const siteToEdit = sites[globalIndex]; // Get from the full users array
    // const siteToEdit = currentSites[index]; // Get the site from current view
    // const originalIndex = sites.findIndex((site) => site.name === siteToEdit.name); // Map to original array

    if (siteData) {
      // Populate form fields
      setName(siteData.name);
      setURL(siteData.URL);
      setDescription(siteData.description);
      setIsActive(siteData.isActive);
      setquickLinkId(siteData.projectLinkID);
      setEditingId(siteData.projectLinkID); // Use original index for updates
      setSelectedQuickLinkRole(
        siteData.source ? siteData.source.toString() : ""
      );
      setSelectedType(siteData.type ? siteData.type.toString() : "");
      setIsModalOpen(true);

      console.log("EDITING Site is==>>>", siteData);
    }
  };

  const openDeleteModal = (quickLinkId: number) => {
    // const siteName = sites[index].name; // Assuming 'sites' is the array holding your site data and 'name' is the field containing the site name
    // setDeleteSiteName(siteName);
    setDeleteIndex(quickLinkId);
    setIsDeleteModalOpen(true); // Open the modal
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setDeleteSiteName(null);
    setDeleteIndex(null); // Clear the states
  };

  const confirmDelete = async () => {
    if (deleteIndex === null) return;

    // Check for required data
    if (!accessToken || !userData || typeof userData.userID !== "number") {
      toast({
        position: "top",
        title: "Error",
        description: "Missing access token or user data. Cannot delete site.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const siteIdforDelete = deleteIndex.toString();

      await deleteQuickLink(
        siteIdforDelete,
        accessToken,
        tenantID,
        userData.userID
      );

      toast({
        position: "top",
        title: "Project link Deleted",
        description: `The project links "${deleteSiteName}" has been deleted successfully.`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      getQuickLinks(); // Refresh data
    } catch (error) {
      console.error("Delete Error:", error);
      setError("Failed to delete site.");
      toast({
        position: "top",
        title: "Error",
        description: "An error occurred while deleting the project link.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
      closeDeleteModal();
    }
  };

  const handleOpenModal = () => {
    handleReset();
    setIsActive(true);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleReset = () => {
    setName("");
    setURL("");
    setSelectedQuickLinkRole("");
    setDescription("");
    setIsActive(false);
    setEditingId(null);
  };

  const handleItemsPerPageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1); // Reset to the first page when items per page changes
  };

  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  // Filter the sites based on the search query
  const filteredSites = sites.filter((site) =>
    site.name.toLowerCase().includes(search.toLowerCase())
  );

  // Pagination Logic
  const totalSites = filteredSites.length; // Get total number of filtered sites
  const totalPages = Math.ceil(totalSites / itemsPerPage); // Calculate total pages
  const indexOfLastSite = currentPage * itemsPerPage;
  const indexOfFirstSite = indexOfLastSite - itemsPerPage;
  const currentSites = filteredSites.slice(indexOfFirstSite, indexOfLastSite); // Slice the filtered sites

  useEffect(() => {
    // Reset to first page when search term changes
    setCurrentPage(1);
  }, [search]);

  const getQuickLinks = async () => {
    try {
      if (accessToken) {
        // Check if accessToken is not null
        const data = await fetchQuickLinks(accessToken, tenantID);
        setSites(data);
        console.log("quick links data::", data);
      } else {
        setError("Access token is missing.");
      }
    } catch (error) {
      setError("Failed to fetch users.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getQuickLinks();
  }, [accessToken]); // Fetch data when accessToken changes

  return (
    <div>
      <Flex justify="space-between" align="center" mb={4} p={6}>
        <Heading as="h2" size="xl" textAlign="center" mb={0}>
          Project Links
        </Heading>
        <Button colorScheme="blue" onClick={handleOpenModal}>
          <i className="bi bi-diagram-2" style={{ marginRight: "8px" }}></i>
          Add Project's Links
        </Button>
      </Flex>

      <Box
        p={6}
        shadow="md"
        borderWidth="1px"
        borderRadius={"15px"}
        backgroundColor={"#fff"}
      >
        <Flex justify="space-between" align="center" mb={4}>
          <Flex justify="space-between" align="center" mb={4}>
            <Select
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
              maxWidth="200px"
            >
              <option value={10}>10 items per page</option>
              <option value={20}>20 items per page</option>
              <option value={30}>30 items per page</option>
            </Select>
          </Flex>
          <FormControl mb={4} maxWidth="300px">
            <Input
              placeholder="Search by name..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </FormControl>
        </Flex>

        <Table variant="simple" className="Table">
          <Thead>
            <Tr>
              <Th>Title</Th>
              <Th>Description</Th>
              <Th>URL</Th>
              <Th>Status</Th>
              <Th>Source</Th>
              <Th>Type</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {currentSites.map((site) => (
              <Tr>
                <Td>{site.name}</Td>
                <Td>{site.description}</Td>
                <Td
                  style={{
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    maxWidth: "220px",
                  }}
                >
                  <a
                    href={
                      site.isActive && site.URL
                        ? site.URL.startsWith("http")
                          ? site.URL
                          : `https://${site.URL}`
                        : "#"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      pointerEvents:
                        site.isActive && site.URL ? "auto" : "none",
                      color: site.isActive && site.URL ? "blue" : "gray",
                    }}
                  >
                    {site.URL}
                  </a>
                </Td>
                <Td>
                  <span
                    className={`status-box ${site.isActive ? "active" : "inactive"
                      }`}
                  >
                    {site.isActive ? "Active" : "Inactive"}
                  </span>
                </Td>
                <Td>{site.source === "Graph" ? "OneDrive" : site.source}</Td>
                <Td>{site.type}</Td>
                <Td>
                  <Flex>
                    <Button
                      size="sm"
                      colorScheme="blue"
                      mr={2}
                      onClick={() => {
                        console.log("Editing site with ID:", site); // Add this log to check
                        handleEdit(site);
                      }}
                    >
                      <i className="bi bi-pencil-square"></i>
                    </Button>

                    <Button
                      size="sm"
                      colorScheme="red"
                      onClick={() => openDeleteModal(site.projectLinkID)} // Pass the correct site index
                    >
                      <i className="bi bi-trash3"></i>
                    </Button>
                  </Flex>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>

        {/* Page Info */}
        <Flex justify="space-between" mt={4}>
          <Box>
            <span>
              Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
              {Math.min(currentPage * itemsPerPage, totalSites)} of {totalSites}{" "}
              entries
            </span>
          </Box>

          {/* Pagination */}
          {/* <HStack spacing={4}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Previous
            </Button>

            <Select
              value={currentPage}
              onChange={(e) => handlePageChange(Number(e.target.value))}
              maxWidth="70px"
            >
              {Array.from({ length: totalPages }, (_, index) => (
                <option key={index} value={index + 1}>
                  {index + 1}
                </option>
              ))}
            </Select>

            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </HStack> */}
          <HStack spacing={4} justify="center" mt={4}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </Button>
            <Text>{`Page ${currentPage} of ${totalPages}`}</Text>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </Button>
          </HStack>
        </Flex>
      </Box>

      <Modal isOpen={isDeleteModalOpen} onClose={closeDeleteModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Confirmation</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {deleteIndex ? (
              <Text>
                Are you sure you want to delete the project link {" "}
                <strong>
                  "{sites.find((a) => a.projectLinkID == deleteIndex)?.name}"
                </strong>
                ?
              </Text>
            ) : (
              <p>Error: Invalid site selected.</p>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" mr={3} onClick={confirmDelete}>
              Delete
            </Button>
            <Button variant="ghost" onClick={closeDeleteModal}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal for adding/updating site */}
      <Modal isOpen={isModalOpen} onClose={handleCloseModal} size={"xl"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {editingId !== null ? "Edit Project Link" : "Add a Project Link"}
          </ModalHeader>
          <ModalCloseButton />
          <hr style={{ border: "1px solid #black" }} />
          <ModalBody>
            <Stack spacing={4}>
              {/* Adjust spacing for better separation */}
              {/* Title */}
              <FormControl isRequired>
                <FormLabel>Title</FormLabel>
                <Input value={name} onChange={(e) => setName(e.target.value)} />
              </FormControl>
              {/* Description  Not Required always*/}
              <FormControl>
                <FormLabel>Description</FormLabel>
                <Input
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </FormControl>
              {/* URL */}
              <FormControl isRequired>
                <FormLabel>URL</FormLabel>
                <Input value={URL} onChange={(e) => setURL(e.target.value)} />
              </FormControl>
              <FormControl isRequired>
                <FormLabel>Platform</FormLabel>
                <Select
                  placeholder="Select Source Type"
                  value={selectedQuickLinkRole}
                  onChange={handlePlatformChange}
                >
                  <option value="SharePoint">Sharepoint</option>
                  <option value="Graph">OneDrive</option>
                  <option value="DropBox">DropBox</option>
                  <option value="DropBoxBusiness">DropBox Business</option>
                </Select>
              </FormControl>

              {/* Type - Conditional dropdown */}
              <FormControl isRequired>
                <FormLabel>Type</FormLabel>
                <Select
                  placeholder="Select Type"
                  value={selectedType}
                  onChange={handleTypeChange}
                  isDisabled={!selectedQuickLinkRole} // Disable if no source is selected
                >
                  {getTypeOptions().map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Select>
              </FormControl>

              {/* Active Checkbox */}
              <FormControl alignItems="center">
                <FormLabel mb={0} mr={4}>
                  Status
                </FormLabel>
                {/* mb={0} removes bottom margin, mr={4} adds space */}
                <Switch
                  isChecked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  colorScheme="blue"
                />
              </FormControl>
            </Stack>
          </ModalBody>

          <hr style={{ border: "1px solid #black" }} />

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleSave}>
              {editingId !== null ? "Update" : "Save"}
            </Button>
            <Button variant="ghost" onClick={handleCloseModal}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default QuickLinks;
